import { capitalize } from 'lodash';

import { ChangeType } from '@zapier/design-system-revenue/src/types';

type ChangePlanLabelProps = {
  changeType: ChangeType;
  isLoggedOutPricingPage: boolean;
  isPlanCardPlanFree: boolean;
  isUserOnLegacyPlan: boolean;
};

export enum PlanActionButtonLabel {
  BuyPlan = 'Buy now',
  ChangePlan = 'Change plan',
  CurrentPlan = 'Current plan',
  ManagePlan = 'Manage plan',
  TryPlan = 'Try free',
  RequestDemo = 'Get a demo',
}

export const getChangePlanLabel = ({
  changeType,
  isLoggedOutPricingPage,
  isPlanCardPlanFree,
  isUserOnLegacyPlan,
}: ChangePlanLabelProps) => {
  if (isLoggedOutPricingPage) {
    return PlanActionButtonLabel.TryPlan;
  }

  if (isUserOnLegacyPlan) {
    return PlanActionButtonLabel.ChangePlan;
  }

  return changeType === 'change'
    ? isPlanCardPlanFree
      ? PlanActionButtonLabel.CurrentPlan
      : PlanActionButtonLabel.ManagePlan
    : `${capitalize(changeType)}`;
};
